/** FA catalog — FE-7: پیشرفت، مسیر مراقبت، ارزیابی مجدد، همراهی خانواده. */
export const progressFa: Record<string, string> = {
  'pg.title': 'پیشرفت',
  'pg.sub':
    'آنچه پرونده امروز نشان می‌دهد — مرحله فعلی مراقبت، حضور به تفکیک هر خدمت، و نوشته‌ای که قضاوت بالینی را حمل می‌کند؛ هر کارت منبع خودش را می‌گوید.',
  'pg.subEmpty': 'پروندهٔ تازه — هیچ‌چیز قفل نیست؛ ارزیابی اولیه نقطهٔ شروع پیشنهادی است.',
  'pg.subLimited':
    'همان صفحه، به تناسب دسترسی — آنچه این نقش نمی‌بیند نام برده می‌شود، و بقیه صفحه کار می‌کند.',
  'pg.openTimeline': 'باز کردن نمای طولی',
  'pg.stageEyebrow': 'مرحله فعلی مراقبت',
  'pg.stageCaption':
    'جای پرونده را همین حالا می‌گوید — با تغییر ارزیابی‌ها، بسته‌ها و جلسات عوض می‌شود، و می‌تواند عقب برود.',
  'pg.stage.pre_registration': 'ثبت‌نام کامل نشده',
  'pg.stage.pre_registrationBody': 'یک تماس اول بدون پرونده کامل‌شده.',
  'pg.stage.registered': 'ثبت‌شده',
  'pg.stage.registeredBody': 'پرونده ساخته شده. نوبت‌گرفتن آزاد است؛ نوشتار بالینی هنوز شروع نشده.',
  'pg.stage.initial_assessment': 'ارزیابی کامل — در انتظار بسته',
  'pg.stage.initial_assessmentBody': 'یک ارزیابی کامل روی پرونده است و هنوز بسته‌ای ساخته نشده.',
  'pg.stage.package': 'بسته موجود است',
  'pg.stage.packageBody': 'بسته‌ای وجود دارد و هنوز جلسه‌ای برگزار نشده.',
  'pg.stage.treatment_delivery': 'ارائه درمان',
  'pg.stage.treatment_deliveryBody': 'دست‌کم یک جلسه برگزار شده و درمان هنوز کامل نیست.',
  'pg.stage.package_completion': 'بسته‌ها کامل',
  'pg.stage.package_completionBody': 'هر بسته فعلی کامل است. قدم بعدی لازم نیست.',
  'pg.stage.reassessment_loop': 'ارزیابی مجدد بعد از تکمیل',
  'pg.stage.reassessment_loopBody':
    'همه بسته‌ها کامل‌اند و یک ارزیابی مجدد جدیدتر امضا شده — بسته بعدی می‌تواند از آن شروع شود.',
  'pg.stageChanged': 'مرحله مراقبت به‌روز شد — از {from} به {to}.',
  'pg.justNow': 'همین حالا',
  'pg.stagePresentTitle': 'مرحله به زمان حال حرف می‌زند',
  'pg.stagePresentBody':
    'این یادداشت فقط چون تغییر همین لحظه پیش این‌جا اتفاق افتاد ظاهر می‌شود؛ بازدید بعدی فقط مرحله فعلی را نشان می‌دهد.',
  'pg.countsCaption': 'فقط شمارش جلسات — هیچ‌وقت معیار تغییر بالینی نیست.',
  'pg.att.done': 'کامل',
  'pg.att.delivery': 'در جریان',
  'pg.att.stalled': 'جلسه‌ای پیش رو نیست',
  'pg.packageTotal': 'جمع بسته',
  'pg.lastDelivered': 'آخرین برگزاری {date} · چیزی پیش رو زمان‌بندی نشده. فقط شمارش جلسات.',
  'pg.openScheduling': 'باز کردن زمان‌بندی',
  'pg.viewPackage': 'دیدن بسته',
  'pg.stalledTitle': 'هیچ جلسه پیش رویی رزرو نشده',
  'pg.stalledBody':
    'جلساتی روی یک بسته ناقص مانده و هیچ‌کدام رزرو نشده. این یک واقعیت زمان‌بندی است، نه قضاوت بالینی — هر وقت خانواده آماده بود جلسه بعدی را رزرو کنید.',
  'pg.multiTitle': 'تکمیل به همه بسته‌ها نیاز دارد',
  'pg.multiBody':
    'با یک بسته باز، پرونده در «ارائه درمان» می‌ماند — بسته تمام‌شده واقعیت خود همان بسته است.',
  'pg.emptyTitle': 'هنوز چیزی برای خواندن نیست',
  'pg.emptyBody':
    'نه بسته‌ای، نه ارزیابی‌ای، نه جلسه‌ای. نوبت‌گرفتن آزاد است؛ نوشتار بالینی از اولین ارزیابی شروع می‌شود.',
  'pg.expected': 'نتایج مورد انتظار',
  'pg.expectedChip': 'نوشته ارزیابی',
  'pg.expectedNone': 'هیچ نتیجه مورد انتظاری برای این ارزیابی ثبت‌نشده.',
  'pg.observation': 'آخرین مشاهده نتیجه',
  'pg.observationChip': 'یادداشت جلسه',
  'pg.observationNone': 'هنوز هیچ مشاهده نتیجه‌ای ثبت‌نشده.',
  'pg.familyGoals': 'اهداف زمینه خانواده',
  'pg.familyGoalsChip': 'معارفه · گفتهٔ خانواده',
  'pg.familyGoalsChipStaff': 'معارفه · با کمک کارکنان',
  'pg.familyGoalsChipNone': 'معارفه',
  'pg.familyGoalsNone': 'در معارفه هدف زمینه‌ای‌ای ثبت نشده.',
  'pg.familyGoalsMeta': 'معارفه · {date} · گفتهٔ خانواده',
  'pg.familyGoalsMetaStaff': 'معارفه · {date} · ثبت‌شده توسط کارکنان مرکز',
  'pg.readInContext': 'خواندن در زمینه',
  'pg.limitedTitle': 'نوشته‌های بالینی',
  'pg.limitedChip': 'در دسترسی شما نیست',
  'pg.limitedBody':
    'نوشته‌های ارزیابی و جلسه جزو نقش شما نیست. حضور، مرحله مراقبت و زمان‌بندی کاملا در دسترس می‌مانند.',
  'pg.limitedAssessBody':
    'نوشته‌های ارزیابی جزو نقش شما نیست. بقیه این صفحه، از جمله مشاهدات جلسه، در دسترس می‌ماند.',
  'pg.limitedSessionsBody':
    'نوشته‌های جلسه جزو نقش شما نیست. بقیه این صفحه، از جمله نوشته ارزیابی، در دسترس می‌ماند.',
  'pg.completionStrip':
    'وقتی یک تصویر بالینی تازه کمک می‌کند، ارزیابی مجدد می‌تواند شروع شود — هیچ‌وقت الزامی نیست.',
  'pg.startReassessment': 'شروع ارزیابی مجدد',
  'pg.nothingRequiredTitle': 'قدم بعدی الزامی نیست',
  'pg.nothingRequiredBody':
    'نوبت‌گرفتن باز می‌ماند و پرونده در وضعیت خوبی است. ارزیابی مجدد یا بستهٔ تازه انتخاب‌اند، نه الزام.',
  'pg.loopStrip': 'بسته بعدی می‌تواند از ارزیابی مجدد شروع شود — یک گزینه، هیچ‌وقت یک الزام.',
  'pg.loopCta': 'ساخت بسته از ارزیابی مجدد',
  'pg.fact1': 'همه بسته‌ها کامل',
  'pg.fact1Body':
    'هر جلسه برنامه‌ریزی‌شده روی هر بسته فعلی برگزار شده — آخرین برگزاری موثر {date}.',
  'pg.fact2': 'ارزیابی مجدد بعد از آخرین برگزاری امضا شد',
  'pg.fact2Body': 'امضا شده توسط {who} · {date}.',
  'pg.viewReassessment': 'دیدن ارزیابی مجدد',
  'pg.loopNoteTitle': 'توصیفی از حالا، نه یک نقطه عطف',
  'pg.loopNoteBody':
    'این وضعیت فقط اکنون را توصیف می‌کند: با شروع بستهٔ تازه کنار می‌رود و چیزی را اجبار نمی‌کند — نوبت‌گرفتن و ارزیابی همیشه آزادند.',
  'pg.factN': 'واقعیت {n, number}',

  'pg.tlTitle': 'تغییر در طول زمان',
  'pg.tlSub':
    'سندهای پرونده به ترتیب زمان — نثر ارزیابی‌ها، مشاهده‌های جلسه‌ها و بافتار معارفه کنار هم. مقایسه و نتیجه‌گیری، قضاوتِ خوانندهٔ بالینی است.',
  'pg.tlHead': 'گاه نگاری',
  'pg.tlHeadSub': 'فقط گاه نگاری — بدون مقایسه رسمی، بدون پیوند علت و معلولی.',
  'pg.tlEmpty': 'هنوز چیزی روی پرونده نیست.',
  'pg.tl.assessment_signed': '{type} · امضا شده',
  'pg.tl.assessment_draft': '{type} · پیش‌نویس',
  'pg.tl.session_observation': 'مشاهده جلسه',
  'pg.tl.session_delivered': 'جلسه برگزار شد',
  'pg.tl.session_voided': 'جلسه · لغو شده',
  'pg.tl.intake': 'معارفه · گفتهٔ خانواده',
  'pg.tlDelivered': 'برگزار شد — هیچ مشاهده نتیجه‌ای وارد نشده.',
  'pg.tlVoided': 'یک برگزاری باطل شد؛ جلسه و یادداشت‌هایش روی پرونده می‌مانند.',
  'pg.tlIntake': 'هدف‌های زمینه‌ای خانواده، در معارفه.',
  'pg.tlDraft': 'یک پیش‌نویس در جریان.',
  'pg.tlSigned': 'یک تصویر بالینی امضا شده.',
  'pg.tlComposed':
    'از اسناد خود پرونده ساخته‌شده؛ یک خوانش گاه نگارانه واحد از سامانه مرکز جای این ترکیب را می‌گرفت.',

  'as.startReassessment': 'شروع ارزیابی مجدد',
  'as.coexistTitle': 'ارزیابی‌ها کنار هم می‌مانند',
  'as.coexistBody':
    'ارزیابی مجدد به ارزیابی قبلی نیاز ندارد و روی پای خود می‌ایستد — اسناد قبلی دست نمی‌خورند.',
  'as.noPrereqTitle': 'بدون پیش‌نیاز، بدون پیوند',
  'as.noPrereqBody':
    'ارزیابی مجدد به ارزیابی اولیه قبلی نیاز ندارد و روی پای خود می‌ایستد — اسناد قبلی دست نمی‌خورند.',
  'pk.reassessNoteTitle': 'ارزیابی مجدد بسته‌های موجود را خودکار عوض نمی‌کند',
  'pk.reassessNoteBody':
    'بسته‌های موجود نه بسته، نه تمدید و نه دوباره قیمت می‌شوند — این بسته جدید تصمیم خودش است، و اصلاحیه‌های بعدی ارزیابی هیچ‌وقت در آن جاری نمی‌شوند.',
  'rec.progressSub': 'مرحله فعلی مراقبت، حضور به تفکیک هر خدمت، و نوشته‌ای که قضاوت را حمل می‌کند.',
  'rec.openProgress': 'دیدن پیشرفت',
};
